import { render, staticRenderFns } from "./DashboardProcesso.vue?vue&type=template&id=5dde6ade&scoped=true"
import script from "./DashboardProcesso.vue?vue&type=script&lang=js"
export * from "./DashboardProcesso.vue?vue&type=script&lang=js"
import style0 from "./DashboardProcesso.vue?vue&type=style&index=0&id=5dde6ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde6ade",
  null
  
)

export default component.exports